import { useState } from 'react';
import { ApiFailure, api, deviceId, deviceLabel, tokens } from '../lib/api';
import { Bike } from 'lucide-react';

interface LoginResult {
  accessToken: string;
  refreshToken: string;
  mustChangePassword: boolean;
  user: { id: string; name: string; kind: string };
}

export function Login({ onDone }: { onDone: (mustChangePassword: boolean) => void }) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (busy) return;
    setError(null);
    setBusy(true);
    try {
      const r = await api<LoginResult>('/auth/login', {
        method: 'POST',
        noRetry: true,
        body: {
          identifier: phone.trim(),
          password,
          deviceId: deviceId(),
          deviceLabel: deviceLabel(),
        },
      });
      tokens.set({ accessToken: r.accessToken, refreshToken: r.refreshToken });
      onDone(r.mustChangePassword);
    } catch (e) {
      // 后端已经把错误翻译成人话,直接显示
      setError(e instanceof ApiFailure ? e.message : '网络异常,请稍后重试');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-dvh flex flex-col justify-center px-6 bg-slate-50 dark:bg-slate-900">
      {/*
        ★ 限宽居中。这一端确实是给手机做的,但它在电脑浏览器里照样打得开
          (调度自己要试、司机也会在电脑上登一次改密码)——
          不限宽的话两个框会被拉到一整屏那么长。

          框本身**不跟着缩**:56px 高、18px 字是给戴手套的手指留的,
          在平板上这个理由依然成立。这里要修的是宽度,不是尺寸。
      */}
      <div className="mx-auto w-full max-w-sm">
        <div className="mb-10 text-center">
          <Bike className="mx-auto mb-3 size-12 text-brand-600" />
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">司机端</h1>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label htmlFor="phone" className="block text-sm text-slate-600 dark:text-slate-400 mb-1.5">
              手机号
            </label>
            <input
              id="phone"
              type="tel"
              inputMode="tel"
              autoComplete="username"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="0123456789"
              // 字号 18px:司机可能在阳光下、戴手套操作
              className="w-full h-14 px-4 text-lg rounded-xl border border-slate-300 dark:border-slate-700
                         bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100
                         focus:outline-none focus:ring-2 focus:ring-brand-500"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm text-slate-600 dark:text-slate-400 mb-1.5">
              密码
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-14 px-4 text-lg rounded-xl border border-slate-300 dark:border-slate-700
                         bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100
                         focus:outline-none focus:ring-2 focus:ring-brand-500"
            />
          </div>

          {error && (
            <div className="rounded-xl bg-red-50 dark:bg-red-950 border border-red-200 dark:border-red-900
                            px-4 py-3 text-red-700 dark:text-red-300">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={busy || !phone || !password}
            className="w-full h-14 rounded-xl bg-brand-600 text-white text-lg font-medium
                       disabled:opacity-40 active:bg-brand-700 transition"
          >
            {busy ? '登录中…' : '登录'}
          </button>
        </form>

        <p className="mt-8 text-center text-sm text-slate-500">
          忘记密码请联系管理员重置
        </p>
      </div>
    </div>
  );
}
